export const AdvancedHostingActionTypes = {
  // Listagem de servidores
  ADVANCED_HOSTING_LIST_REQUEST: 'ADVANCED_HOSTING_LIST_REQUEST',
  ADVANCED_HOSTING_LIST_SUCCESS: 'ADVANCED_HOSTING_LIST_SUCCESS',
  ADVANCED_HOSTING_LIST_FAILURE: 'ADVANCED_HOSTING_LIST_FAILURE',
  ADVANCED_HOSTING_LIST_LOADING: 'ADVANCED_HOSTING_LIST_LOADING',

  // Atualização de servidor
  ADVANCED_HOSTING_UPDATE_SERVER_REQUEST: 'ADVANCED_HOSTING_UPDATE_SERVER_REQUEST',
  ADVANCED_HOSTING_UPDATE_SERVER_SUCCESS: 'ADVANCED_HOSTING_UPDATE_SERVER_SUCCESS',
  ADVANCED_HOSTING_UPDATE_SERVER_FAILURE: 'ADVANCED_HOSTING_UPDATE_SERVER_FAILURE',
  ADVANCED_HOSTING_UPDATE_SERVER_LOADING: 'ADVANCED_HOSTING_UPDATE_SERVER_LOADING',

  // Parâmetros do último GET de listagem
  ADVANCED_HOSTING_SET_LAST_LIST_PARAMS: 'ADVANCED_HOSTING_SET_LAST_LIST_PARAMS',

  // Status individual de servidor
  ADVANCED_HOSTING_SERVER_STATUS_REQUEST: 'ADVANCED_HOSTING_SERVER_STATUS_REQUEST',
  ADVANCED_HOSTING_SERVER_STATUS_SUCCESS: 'ADVANCED_HOSTING_SERVER_STATUS_SUCCESS',
  ADVANCED_HOSTING_SERVER_STATUS_FAILURE: 'ADVANCED_HOSTING_SERVER_STATUS_FAILURE',
  ADVANCED_HOSTING_SERVER_STATUS_LOADING: 'ADVANCED_HOSTING_SERVER_STATUS_LOADING',
};
